var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',_vm._g(_vm._b({ref:"alert",attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-alert',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }